import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {PopoverProductStatusPage} from './popover-product-status';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    PopoverProductStatusPage,
  ],
  imports: [
    IonicPageModule.forChild(PopoverProductStatusPage),
    TranslateModule.forChild()
  ],
})
export class PopoverProductStatusPageModule {}



// WEBPACK FOOTER //
// ./src/pages/popover-product-status/popover-product-status.module.ts